import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  FacebookAuthProvider,
  signInWithEmailLink,
  sendSignInLinkToEmail, // Import sendSignInLinkToEmail
} from "firebase/auth";
import { firebaseAuth } from "../config/firebase";

export const signUpWithEmail = async (email: string, password: string) => {
  const userCredential = await createUserWithEmailAndPassword(
    firebaseAuth,
    email,
    password
  );
  return userCredential.user;
};

export const signInWithEmail = async (email: string, password: string) => {
  const userCredential = await signInWithEmailAndPassword(
    firebaseAuth,
    email,
    password
  );
  return userCredential.user;
};

export const signInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  const userCredential = await signInWithPopup(firebaseAuth, provider);
  return userCredential.user;
};

export const signInWithFacebook = async () => {
  const provider = new FacebookAuthProvider();
  const userCredential = await signInWithPopup(firebaseAuth, provider);
  return userCredential.user;
};

export const sendSignInLinkToEmailService = async (email: string) => {
  const actionCodeSettings = {
    url: window.location.href, // Redirect URL
    handleCodeInApp: true, // Handle the code in the app
  };
  await sendSignInLinkToEmail(firebaseAuth, email, actionCodeSettings);
};

export const signInWithEmailLinkService = async (
  email: string,
  link: string
) => {
  const userCredential = await signInWithEmailLink(firebaseAuth, email, link);
  return userCredential.user;
};

export const getIdToken = async () => {
  const user = firebaseAuth.currentUser;
  if (user) {
    return await user.getIdToken();
  }
  throw new Error("User is not authenticated");
};
